import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

@Component({
  selector: 'fin-inform-block',
  templateUrl: './inform-block.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class InformBlockComponent {
  readonly SvgLibraryIcon = SvgLibraryIcon;

  @Input() title: string;
}
